// import React, { useState } from 'react';
// import { MdModeEditOutline, MdDelete } from 'react-icons/md';
// import SummaryApi from '../../common/SummaryApi';
// import { toast } from 'react-toastify';
// import UploadCoupon from './UploadCoupon';

// const AdminCouponCard = ({ data, fetchData }) => {
//   const [editOpen, setEditOpen] = useState(false);

//   console.log(data);
  

//   const handleDelete = async () => {
//     const response = await fetch(`${SummaryApi.deleteCoupon.url(data._id)}`, {
//       method: SummaryApi.deleteCoupon.method,
//     });
//     const resData = await response.json();
//     if (resData.success) {
//       toast.success(resData.message);
//       fetchData();
//     }
//   };

//   const handleToggleStatus = async () => {
//   try {
//     const response = await fetch(
//       `${SummaryApi.toggleCoupon.url(data._id)}`,
//       {
//         method: SummaryApi.toggleCoupon.method, // PUT
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           isActive: !data.isActive   // 🔥 explicit toggle
//         })
//       }
//     );

//     const resData = await response.json();

//     if (!response.ok) {
//       throw new Error(resData.message || "Failed to update status");
//     }

//     toast.success(resData.message);
//     fetchData();

//   } catch (err) {
//     console.error("Toggle coupon error:", err);
//     toast.error(err.message || "Something went wrong");
//   }
// };


//   return (
//     <div className="bg-white p-4 rounded-lg shadow border-l-4 border-blue-500">
//       <div className="flex justify-between items-start">
//         <div>
//           <h2 className="text-xl font-bold text-gray-800">{data.code}</h2>
//           <p className="text-sm text-gray-500">{data.discountType === 'percentage' ? `${data.discountValue}% OFF` : `₹${data.discountValue} FLAT OFF`}</p>
//         </div>
//         <div className={`px-2 py-1 rounded text-xs ${data.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
//           {data.isActive ? 'Active' : 'Inactive'}
//         </div>
//       </div>

//       <div className="mt-4 text-sm space-y-1">
//         <p><b>Min Order:</b> ₹{data.minOrderAmount}</p>
//         {data.expiryDate && <p><b>Expires:</b> {new Date(data.expiryDate).toLocaleDateString()}</p>}
//         <p><b>Used:</b> {data.usedCount} / {data.usageLimit || '∞'}</p>
//       </div>

//       <div className="flex justify-end gap-3 mt-4 border-t pt-3">
//         <button onClick={handleToggleStatus} className="text-xs text-blue-600 underline">
//           {data.isActive ? "Disable" : "Enable"}
//         </button>
//         <button onClick={() => setEditOpen(true)} className="p-2 bg-green-100 hover:bg-green-600 rounded-full hover:text-white transition-all">
//           <MdModeEditOutline />
//         </button>
//         <button onClick={handleDelete} className="p-2 bg-blue-100 hover:bg-blue-600 rounded-full hover:text-white transition-all">
//           <MdDelete />
//         </button>
//       </div>

//       {editOpen && (
//         <UploadCoupon 
//             onClose={() => setEditOpen(false)} 
//             fetchData={fetchData} 
//             editData={data} 
//         />
//       )}
//     </div>
//   );
// };

// export default AdminCouponCard;

import React, { useState } from 'react';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import SummaryApi from '../../common/SummaryApi';
import { toast } from "react-hot-toast";
import UploadCoupon from './UploadCoupon';

const AdminCouponCard = ({ data, fetchData }) => {
  const [editOpen, setEditOpen] = useState(false);

  const handleDelete = async () => {
    if(!window.confirm("Are you sure you want to delete this coupon?")) return;
    
    try {
        const response = await fetch(`${SummaryApi.deleteCoupon.url(data._id)}`, {
            method: SummaryApi.deleteCoupon.method,
        });
        const resData = await response.json();
        if (resData.success) {
            toast.success(resData.message);
            fetchData();
        }
    } catch (error) {
        toast.error("Delete failed");
    }
  };

  const handleToggleStatus = async () => {
    try {
      const response = await fetch(
        `${SummaryApi.toggleCoupon.url(data._id)}`,
        {
          method: SummaryApi.toggleCoupon.method,
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            isActive: !data.isActive 
          })
        }
      );

      const resData = await response.json();

      if (!response.ok) {
        throw new Error(resData.message || "Failed to update status");
      }

      toast.success(resData.message);
      fetchData();

    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  return (
    <>
      <div className={`bg-white p-5 rounded-xl shadow-sm border-t-4 transition-all ${data.isActive ? 'border-blue-600 shadow-md' : 'border-gray-300 opacity-75'}`}>
        <div className="flex justify-between items-start mb-2">
          <div>
            <h2 className="text-2xl font-black text-blue-800 tracking-tight">{data.code}</h2>
            <p className="text-sm font-bold text-gray-600">
                {data.discountType === 'percentage' ? `${data.discountValue}% OFF` : `₹${data.discountValue} FLAT OFF`}
            </p>
          </div>
          <div className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase ${data.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
            {data.isActive ? 'Live' : 'Paused'}
          </div>
        </div>

        <div className="mt-4 text-xs space-y-2 text-gray-700 border-b pb-3">
          <div className='flex justify-between'>
              <span><b>Min Order:</b> ₹{data.minOrderAmount}</span>
              {data.maxDiscountAmount && <span><b>Max Discount:</b> ₹{data.maxDiscountAmount}</span>}
          </div>
          {data.expiryDate && <p><b>Expires:</b> {new Date(data.expiryDate).toLocaleDateString()}</p>}
          
          {/* Restriction Badges */}
          <div className='flex flex-wrap gap-1 mt-2'>
              {data.topCategory && <span className='bg-blue-50 text-blue-600 px-2 py-0.5 rounded'>Cat: {data.topCategory?.name}</span>}
              {data.products?.length > 0 && <span className='bg-purple-50 text-purple-600 px-2 py-0.5 rounded'>{data.products.length} Products Only</span>}
          </div>
        </div>

        <div className='mt-3 flex justify-between items-center'>
            <p className='text-[10px] text-gray-400 uppercase font-bold tracking-widest'>Usage: {data.usedCount} / {data.usageLimit || '∞'}</p>
            <div className="flex gap-2">
              <button onClick={handleToggleStatus} className={`text-[10px] font-bold py-1 px-3 rounded border transition-all ${data.isActive ? 'text-gray-500 border-gray-300' : 'text-blue-600 border-blue-600'}`}>
                  {data.isActive ? "Disable" : "Enable"}
              </button>
              <button onClick={() => setEditOpen(true)} className="p-2 text-green-600 hover:bg-green-50 rounded-lg">
                  <MdModeEditOutline size={18}/>
              </button>
              <button onClick={handleDelete} className="p-2 text-red-600 hover:bg-red-50 rounded-lg">
                  <MdDelete size={18}/>
              </button>
            </div>
        </div>

      </div>
      {editOpen && (
        <UploadCoupon 
            onClose={() => setEditOpen(false)} 
            fetchData={fetchData} 
            editData={data} 
        />
      )}
    </>
  );
};

export default AdminCouponCard;